import Loadable from "react-loadable";
import { Null } from "@clockwise/web-commons/src/components/null";

//////////////////
// LOADABLE
//////////////////
export const OnboardingNUX = Loadable({
  loader: () =>
    import(/* webpackChunkName: "onboarding-nux" */ "./OnboardingNUXRenderer").then(
      ({ OnboardingNUXRenderer: c }) => c,
    ),
  loading: Null,
});
